import script from "./SessionChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionChatView.vue?vue&type=script&setup=true&lang=js"

import "./SessionChatView.vue?vue&type=style&index=0&id=6b9e5a8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9e5a8a"]])

export default __exports__